import React from 'react';

export default function Forbidden() {
    return (
        <div className="flex flex-col items-center justify-center h-full min-h-[60vh] text-center px-6">
            <h1 className="text-xl font-light uppercase tracking-widest text-text-main mb-3">
                Access Denied
            </h1>
            <p className="text-text-muted max-w-md">
                Your account does not have access to this application. Contact your
                administrator if you believe this is a mistake.
            </p>
        </div>
    );
}
